import { LiveChatCSS } from '@/types/layouts'

const DefaultCss: LiveChatCSS = {
  background: {
    borderradius: 2,
    color: 'rgb(242, 70, 55)',
  },
  username: {
    color: '#FFF',
    left: 5,
    top: 0,
    font: 'Work Sans',
    fontsize: 12
  },
  text: {
    color: '#FFF',
    font: 'Work Sans',
    left: 5,
    top: 3,
    fontsize: 10,
    padding: 10,
    visible: true
  }
}

export default DefaultCss
